import { FORM_STEPS } from 'pages/ContinueApplication/constants';
import Disclaimer from 'pages/ApplyForFinance/Pages/Disclaimer';
import AcceptTerms from 'pages/ApplyForFinance/Pages/AcceptTerms';
import Welcome from './Welcome';
import AdditionalInfo from './AdditionalInfo';

export default {
  [FORM_STEPS.WELCOME]: Welcome,
  [FORM_STEPS.DISCLAIMER]: Disclaimer,
  [FORM_STEPS.ACCEPT_TERMS]: AcceptTerms,
  [FORM_STEPS.ADDITIONAL_INFO]: AdditionalInfo,
};
